import React from 'react';
import TweenOne from 'rc-tween-one';
// import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature14 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItemArr(data) {
      return data.map((key, i) => {
        const { title, img, ...other } = key;
        return (
          <div {...other} key={i}>
            <div {...img}>
              <img src={img.children} alt="" />
            </div>
            <TweenOne
              animation={{
                y: 0,
                duration: 800,
              }}
              delay={400}
              style={{ transform: 'translateY(80px)' }}
              {...title}
            >
              <span dangerouslySetInnerHTML={{ __html: title.children }} />
            </TweenOne>
          </div>
        );
      }
      );
    }

    function getItem(data) {
      const { box, img, ...other } = data;
      const { content, title, ...otherBox } = box;
      return (
        <div {...other}>
          <div {...img}>
            <img src={img.children} alt="" />
          </div>
          <TweenOne
            animation={{
              y: 0,
              duration: 800,
            }}
            delay={300}
            style={{ transform: 'translateY(380px)' }}
            {...otherBox}
          >
            <div {...title}><span dangerouslySetInnerHTML={{ __html: title.children }} /></div>
            <div
              {...content}
            >
              {
              content.children.map((key, i) => {
                return (
                  <div {...key} key={i}>
                    <span dangerouslySetInnerHTML={{ __html: key.children }} />
                  </div>
                );
              })
            }
            </div>
          </TweenOne>
        </div>
      );
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.page}>
          <TweenOne
            animation={{
              scale: 1,
              duration: 300,
            }}
            style={{ transform: 'scale(0)' }}
            {...dataSource.title}
          >
            {
            dataSource.title.children.map(getChildrenToRender)
          }
          </TweenOne>
          <div
            {...dataSource.content}
          >
            <TweenOne
              animation={{
                x: 0,
                duration: 300,
              }}
              style={{ transform: 'translateX(-80px)' }}
              {...dataSource.content.left}
            >
              {getItem(dataSource.content.left.children)}
            </TweenOne>
            <TweenOne
              animation={{
                x: 0,
                duration: 300,
              }}
              style={{ transform: 'translateX(80px)' }}
              {...dataSource.content.right}
            >
              {getItemArr(dataSource.content.right.children)}
            </TweenOne>
          </div>
        </div>
      </OverPack>
    );
  }
}
export default Feature14;
